import LogoSaiten from '@/assets/saiten-logo-white.png';
import type { CustomerVariables } from '@/@types/globals';

export function defineVariables(defaultVariables: CustomerVariables): CustomerVariables {
    defaultVariables.logo = { image: LogoSaiten, width: 200, height: 80, alt: 'saiten.ch Logo' };
    defaultVariables.signupUrl = '/registration/veranstalter';
    defaultVariables.loginFooterHtml = `
        <p class="saiten-paragraph-text">
        (c) 2009-${new Date().getFullYear()} Ostschweizer Kulturmagazin Saiten<br>
        <a href="https://www.saiten.ch/datenschutzerklaerung">Datenschutz</a> |
        <a href="https://www.saiten.ch/impressum">Impressum</a>
        </p>
        `;
    defaultVariables.vuetifyThemeColors = {
        primary: '#231F20',
        primaryToggled: '#9c9597',
        secondary: '#424242',
        anchor: '#81ADD5',
        accent: '#9ACC66',
        action: '#81ADD5',
        error: '#FF5252',
        attention: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
    };
    defaultVariables.mainNavDrawerCollapseIconColor = 'white';
    return defaultVariables;
}
